/**
 * Маска для российских номеров: +7 (900) 000 00 00
 * Применяется ко всем полям с классом .footer-input__phone
 */
export const phoneMask = (root = document) => {
  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length === 0) return '';
    let d = digits;
    if (d[0] === '8' || d[0] === '7') {
      d = d.slice(1);
    }
    if (d.length === 0) return '+7';
    if (d.length <= 3) return `+7 (${d}`;
    if (d.length <= 6) return `+7 (${d.slice(0, 3)}) ${d.slice(3)}`;
    if (d.length <= 8) return `+7 (${d.slice(0, 3)}) ${d.slice(3, 6)} ${d.slice(6)}`;
    return `+7 (${d.slice(0, 3)}) ${d.slice(3, 6)} ${d.slice(6, 8)} ${d.slice(8, 10)}`;
  };

  const handleInput = (e) => {
    const input = e.target;
    const cursorPos = input.selectionStart;
    const oldLen = input.value.length;
    const formatted = formatPhone(input.value);
    input.value = formatted;
    const newLen = formatted.length;
    const newPos = Math.max(0, cursorPos + (newLen - oldLen));
    input.setSelectionRange(newPos, newPos);
  };

  root.querySelectorAll('.footer-input__phone').forEach((input) => {
    // Чтобы не навешивать маску дважды на один и тот же инпут
    if (input.dataset.phoneMaskInited === '1') return;
    input.dataset.phoneMaskInited = '1';

    input.type = 'text';
    input.inputMode = 'tel';
    input.autocomplete = 'tel';
    input.maxLength = 18;
    input.addEventListener('input', handleInput);
    input.addEventListener('paste', (e) => {
      e.preventDefault();
      const pasted = (e.clipboardData?.getData('text') || '').replace(/\D/g, '');
      if (pasted) {
        const formatted = formatPhone(pasted);
        input.value = formatted;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  });
};
